import type { CacheBackend } from "../../types/CacheBackend"
import { MemoryCache } from "./MemoryCache"

export const CacheFunction = <T, G>(
  fn: (or: G) => Promise<T>,
  serializer: (v: G) => string,
  backend?: CacheBackend<T>
): ((expr: G) => Promise<T>) => {
  const cache = backend || MemoryCache<T>()

  return async (expr: G): Promise<T> => {
    const key = serializer(expr)

    const cached = await cache.get(key)

    if (cached === undefined) {
      const result = await fn(expr)
      await cache.set(key, result)
      return result
    }
    return cached
  }
}
